// ** Initial user ability
export const initialAbility = [
  {
    action: 'read',
    subject: 'ACL'
  },
  {
    action: 'read',
    subject: 'Auth'
  }
]

export const _ = undefined
